import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const Container = styled.div<{ $isDisabled: boolean }>(({ $isDisabled }) => ({
    display: "block",
    flex: 1,
    filter: $isDisabled ? "grayscale(100%)" : "none",
    WebkitFilter: $isDisabled ? "grayscale(100%)" : "none",
}));

export const Name = styled.div(({ theme }) => ({
    padding: `${theme.spacing.empty} ${theme.spacing.medium}`,
    verticalAlign: "middle",
    overflow: "hidden",
}));

export const NameWrapper = styled.div<{ $isDisabled: boolean }>(({ $isDisabled }) => ({
    display: "flex",
    alignItems: "center",
    filter: $isDisabled ? "grayscale(100%)" : "none",
    WebkitFilter: $isDisabled ? "grayscale(100%)" : "none",
}));

export const TruncateText = styled.div`
    word-break: break-all;
`;

export const PromoMsg = styled.div<{ $isDisabled: boolean }>(({ theme, $isDisabled }) => ({
    marginTop: theme.spacing.xxxSmall,
    color: $isDisabled ? theme.colors[theme.colorMode].negative : undefined,
}));

export const SuperScriptText = styled.div<{ $isDisabled: boolean }>(({ $isDisabled }) => ({
    filter: $isDisabled ? "grayscale(100%)" : "none",
    WebkitFilter: $isDisabled ? "grayscale(100%)" : "none",
}));

export const DiscountCallout = styled.div<{ $isDisabled: boolean }>(({ theme, $isDisabled }) => ({
    marginTop: theme.spacing.xxxSmall,
    filter: $isDisabled ? "grayscale(100%)" : "none",
    WebkitFilter: $isDisabled ? "grayscale(100%)" : "none",
}));

export const DiscountList = styled.ul(({ theme }) => ({
    listStyle: "none",
    padding: 0,
    margin: 0,
    marginTop: theme.spacing.xxxSmall,
}));

export const DiscountBulletItem = styled.li(({ theme }) => ({
    position: "relative",
    paddingLeft: theme.spacing.xSmall,
    marginBottom: theme.spacing.xxxSmall,

    "&:last-child": {
        marginBottom: 0,
    },

    "&:before": {
        content: '""',
        position: "absolute",
        top: "6px",
        left: 0,
        width: "3px",
        height: "3px",
        backgroundColor: theme.colors[theme.colorMode].positive,
        borderRadius: theme.cornerRadius.rounded,
    },
}));

export const Badge = styled.div(({ theme }) => ({
    textAlign: "center",
    padding: "2px 4px 1px",
    position: "relative",
    background: theme.colors[theme.colorMode].primary,
    borderRadius: theme.cornerRadius.xxSmall,
    marginLeft: theme.spacing.xSmall,
    marginBottom: theme.spacing.xxxSmall,
}));

export const RecommendedTag = styled(Text)(({ theme }) => ({
    background: `linear-gradient(90deg, ${theme.colors[theme.colorMode].background_Button_Secondary} 0.11%, ${theme.colors[theme.colorMode].background_Primary} 35.78%)`,
    borderRadius: theme.cornerRadius.medium,
    padding: `${theme.spacing.xxxSmall} ${theme.spacing.xSmall}`,
    marginBottom: theme.spacing.xxSmall,
}));
